import dayjs from 'dayjs';
import { GasTrendItem } from '.';
import { formatOneDecimalOrDash } from '@/utils/utils';
import { normalizeFieldSeriesUnit } from '@/pages/WgqAllMaps/utils';

export const COLORS = ['#52E7FF', '#CE90D1'];

export const option = (timeFormat: string, selectedMedium?: GasTrendItem) => {
  if (!selectedMedium) return {};
  const trendDetails = selectedMedium.gasUsageTrendDetails ?? [];

  const valueKeys = selectedMedium.isEnergyLedgerPeriod ? ['regularUsage', 'delayUsage'] : ['totalUsage'];
  const { unit, normalizedData } = normalizeFieldSeriesUnit(trendDetails, {
    valueKeys,
    baseUnit: selectedMedium.physicalUnitName ?? '--',
  });

  return {
    backgroundColor: 'transparent',
    color: COLORS,
    grid: {
      left: 10,
      right: 10,
      top: 40,
      bottom: 10,
      containLabel: true,
    },
    legend: {
      right: 20,
      top: 4,
      itemWidth: 12,
      itemHeight: 12,
      icon: 'rect',
    },
    tooltip: {
      trigger: 'axis',
      formatter: (params: any) => {
        if (!Array.isArray(params) || params.length === 0) return '';
        const time = params[0]?.axisValue ?? '';
        let html = `<div style='font-size: 12px;color: rgba(255,255,255,0.65);line-height: 17px;'>${time}</div>`;
        let total = 0;
        params.forEach((p: any) => (total += p.value ?? 0));
        params.forEach((p: any) => {
          const pct = total > 0 ? ((p.value ?? 0) / total) * 100 : 0;
          html += `<div style="display:flex;align-items:center;gap:16px;margin:8px 0">
              <span style="display:inline-block;width:8px;height:8px;border-radius:50%;margin-right:-12px;background:${
                p.color
              }"></span>
              <span>${p.seriesName}</span>
              ${selectedMedium.isEnergyLedgerPeriod ? `<span style="width:50px; ">${pct.toFixed(1)}%</span>` : ''}
              <span >${formatOneDecimalOrDash(p.value, 1)}${unit}</span>
            </div>`;
        });
        return html;
      },
    },
    xAxis: {
      showMinLabel: true,
      showMaxLabel: true,
      hideOverlap: true,
      data: normalizedData.map(d => dayjs(d.time, 'x').format(timeFormat)),
    },
    yAxis: {
      type: 'value',
      name: unit,
    },
    series: selectedMedium.isEnergyLedgerPeriod
      ? [
          {
            name: '常规用能',
            type: 'line',
            smooth: true,
            showSymbol: false,
            emphasis: {
              focus: 'series',
            },
            data: normalizedData.map(d => d.regularUsage),
            stack: '总量',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(72, 201, 244, 0.3)' },
                  { offset: 1, color: 'rgba(72, 201, 244, 0.02)' },
                ],
              },
            },
          },
          {
            name: '延时用能',
            type: 'line',
            smooth: true,
            showSymbol: false,
            emphasis: {
              focus: 'series',
            },
            stack: '总量',
            data: normalizedData.map(d => d.delayUsage),
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(206, 144, 209, 0.10)' },
                  { offset: 1, color: 'rgba(206, 144, 209, 0)' },
                ],
              },
            },
          },
        ]
      : [
          {
            name: '总用能',
            type: 'line',
            smooth: true,
            showSymbol: false,
            emphasis: {
              focus: 'series',
            },
            data: normalizedData.map(d => d.totalUsage),
            itemStyle: {
              color: '#57fb8b',
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(87, 251, 139, 0.3)' },
                  { offset: 1, color: 'rgba(87, 251, 139, 0.02)' },
                ],
              },
            },
          },
        ],
  };
};
